/**
 * Affine Product Image Slider
 * Swiper.js implementation for product page
 */

document.addEventListener('DOMContentLoaded', function () {
    initAffineSwiper();
});

// Also initialize on Shopify theme editor changes
if (document.readyState === 'complete') {
    initAffineSwiper();
}

function initAffineSwiper() {
    const swiperContainer = document.querySelector('.affine-product-swiper');

    if (!swiperContainer) {
        console.log('Affine Swiper: No container found');
        return;
    }

    // Check if Swiper is loaded
    if (typeof Swiper === 'undefined') {
        console.log('Affine Swiper: Waiting for Swiper.js to load...');
        setTimeout(initAffineSwiper, 100);
        return;
    }

    // Initialize Swiper
    const affineSwiper = new Swiper('.affine-product-swiper', {
        // Effect - slide or fade
        effect: 'slide',
        speed: 400,

        // Loop
        loop: true,

        // Grab cursor
        grabCursor: true,

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        // Responsive breakpoints
        breakpoints: {
            // Mobile
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            // Desktop
            990: {
                slidesPerView: 1,
                spaceBetween: 0,
            }
        },

        // Accessibility
        a11y: {
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
        },
    });

    console.log('Affine Swiper initialized successfully with', affineSwiper.slides.length, 'slides');
}
